// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__toww8","label":"SetPasswdForm_label__iORdL"};